import { createFieldSetter } from 'features/libra/stepComponents/niiReport/createFieldSetter'
import { EditableNotes } from 'features/libra/stepComponents/niiReport/NiiFieldComponents'
import { useNiiReportData } from 'features/libra/stepComponents/niiReport/NiiReportDataContext'
import {
  DescriptionItem,
  OptionalDescriptions,
} from 'features/libra/stepComponents/niiReport/OptionalDescriptions'
import { useReferenceValues } from 'features/libra/stepComponents/niiReport/referenceFields'
import React, { FC, useMemo } from 'react'

import { StyledCard } from './cardsStyles'

export const RawNiiAssessmentDetailsCard: FC = () => {
  const { niiData, setNiiData, isLoading } = useNiiReportData()
  const [setJustification, setInspectionNotes] = useMemo(
    () => [
      createFieldSetter('justification', setNiiData),
      createFieldSetter('inspectionNotes', setNiiData),
    ],
    [setNiiData]
  )

  const { values: justificationReferenceValues } =
    useReferenceValues('justification')
  const { values: inspectionNotesReferenceValues } =
    useReferenceValues('inspectionNotes')

  const items = useMemo<ReadonlyArray<DescriptionItem>>(
    () => [
      [
        'Justification',
        <EditableNotes
          key='justification'
          value={niiData?.justification}
          onChange={setJustification}
          referenceValues={justificationReferenceValues}
        />,
      ] as const,
      [
        'Inspection Notes',
        <EditableNotes
          key='inspectionNotes'
          value={niiData?.inspectionNotes}
          onChange={setInspectionNotes}
          referenceValues={inspectionNotesReferenceValues}
        />,
      ] as const,
    ],
    [
      niiData?.justification,
      niiData?.inspectionNotes,
      setJustification,
      setInspectionNotes,
      justificationReferenceValues,
      inspectionNotesReferenceValues,
    ]
  )

  return (
    <StyledCard title='Assessment Details'>
      <OptionalDescriptions isLoading={isLoading} items={items} />
    </StyledCard>
  )
}

export const NiiAssessmentDetailsCard = React.memo(RawNiiAssessmentDetailsCard)
